import React, {Component} from 'react';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

class Staking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newReferralAddress: ''
        };

        this.handleSetReferrer = this.handleSetReferrer.bind(this);
        this.handleReferrerChange = this.handleReferrerChange.bind(this);
    }

    async handleSetReferrer() {
        let addr = this.state.newReferralAddress;
        console.log(addr);
        if (!this.props.data.web3.utils.isAddress(addr)) {
            toast.error(this.props.data.txtResponse.setReferrer.addressNotValid);
            console.log(this.props.data.txtResponse.setReferrer.addressNotValid);
            return;
        }
        try {
            await this.props.data.P3XTokenContract.methods['setReferrer(address)'](addr).send({
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.setReferrer.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    handleReferrerChange(event) {
        let val = event.target.value;
        this.setState({
            newReferralAddress: val
        });
    }

    render() {
        return (

            <div className="row">
                <div className="col-12 mt-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2 text-center">
                                    <h5 className="card-title" style={{display: 'inline-block', paddingLeft: '10px', marginBottom: '6px'}}>
                                        Masternode
                                    </h5>
                                    <p style={{fontSize: '13px', marginBottom: '8px'}}>
                                        Share your masternode to earn extra ETH. If someone buys with your masternode, it will be saved and used next time they buy.
                                        You can also set it with Set Referrer.
                                    </p>
                                    <label className="col-12 mt-0" style={{marginBottom: '0', fontSize: '13px'}}>Minimum Tokens for Masternode</label>
                                    <span id="txt-staking-requirement" style={{fontSize: '13px', color: 'var(--primary)'}}>{this.props.data.stakingRequirementStr}</span>
                                    <label className="col-12 mt-1" style={{marginBottom: '0', fontSize: '13px'}}>Your Masternode</label>
                                    <a id="masternode-link-address" href={this.props.data.masterNodeLink} style={{fontSize: '13px'}}>{this.props.data.masterNodeLink}</a>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                                    <h5 className="card-title text-center">Set Referrer</h5>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">Address:</span>
                                        </div>
                                        <input id="referrer-address" type="text" className="form-control" onChange={this.handleReferrerChange} value={this.state.newReferralAddress}/>
                                    </div>
                                    <button id="btn-set-referrer" type="button" className="btn btn-primary btn-block" onClick={this.handleSetReferrer}>Set Referrer</button>

                                    <p id="txt-current-referrer" className="mt-2 mb-0" style={{fontSize: '14px'}}>
                                        Current Referrer: <a href={this.props.data.etherscanAddr + '/address/' + this.props.data.savedReferral} target="_blank" rel="noopener noreferrer">{this.props.data.savedReferral}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer/>
            </div>

        );
    }
}

export default Staking;